import { Component } from '@angular/core';

@Component({
  selector: 'app-p-ddirect',
  templateUrl: './p-ddirect.component.html',
  styleUrls: ['./p-ddirect.component.scss']
})
export class PDdirectComponent {

}
